var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"inner"},[_c('RegistrationHeader'),_vm._v(" "),_c('main',[_c('section',{staticClass:"content"},[_c('Nuxt')],1)]),_vm._v(" "),_c('RegistrationFooter')],1),_vm._v(" "),_c('ExternalIntegrations')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }